import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import LoginHeader from "../custom_components/LoginHeader";// "../custom_componets/LoginHeader";
import Footer from "../components/Footer/Footer.jsx";

import pagesRoutes from "../routes/pages.jsx";

import pagesStyle from "../assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";

import bgImage from "../assets/img/loginbg.png"
import * as types from '../types'
//mport appStyle from "../assets/jss/material-dashboard-pro-react/layouts/dashboardStyle";

import image from "../assets/img/sidebar-2.jpg";
import logo from "../assets/img/logo-white.svg";
interface LoginLayoutProps {
    classes: any;
    connect: types.IState
  }
  interface LoginLayoutState {
    mobileOpen: boolean;
    miniActive: boolean;
  
  }
class LoginLayout extends React.Component<LoginLayoutProps,LoginLayoutState> {
  componentDidMount() {
    document.body.style.overflow = "unset";
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <LoginHeader {...rest} />
        <div className={classes.wrapper} ref="wrapper">
          <div
            className={classes.fullPage}
            style={{ backgroundImage: "url(" + bgImage + ")" }}
          >
            <Switch>
              {pagesRoutes.map((prop, key) => {
                if (prop.collapse) {
                  return null;
                }
                if (prop.redirect) {
                  return (
                    <Redirect from={prop.path} to={prop.pathTo} key={key} />
                  );
                }
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
            <Footer white />
          </div>
        </div>
      </div>
    );
  }
}
//@ts-ignore
LoginLayout.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(pagesStyle as any)(LoginLayout);



// WEBPACK FOOTER //
// ./src/layouts/LoginLayout.tsx